import { useReducer } from "react"

const AuthDataState = {
  auth: null,
  userData: null,
}

export default AuthDataState
